import * as React from 'react';
import { Classes } from '@blueprintjs/core';
import classnames from 'classnames';
import { TLCode } from '../../../../common/enums';
import { InjectedIntlProps, injectIntl } from 'react-intl';

export interface SelectInputProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  valueKey: string;
  labelKey: string;
  noSelectionText?: TLCode;
  // tslint:disable-next-line:ban-types
  renderOption?: Function;
  selectedOption?: string | number;
  // tslint:disable-next-line:array-type
  options: {
    // tslint:disable-next-line:no-any
    [otherProp: string]: any;
  }[];
}

const SelectInput = (props: SelectInputProps & InjectedIntlProps) => {
  const {
    className,
    options,
    valueKey,
    labelKey,
    noSelectionText,
    renderOption,
    selectedOption,
    ...otherProps
  } = props;

  const intl = props.intl!;

  const getLabel = (option) => (renderOption ? renderOption(option) : option[labelKey]);

  const getNoSelectionText = (): string | null =>
    noSelectionText ? intl.formatMessage({ id: TLCode[noSelectionText] }) : null;

  return (
    <div className={classnames(Classes.SELECT, className)}>
      <select {...otherProps} value={selectedOption}>
        {noSelectionText && <option>{getNoSelectionText()}</option>}
        {options.map((opt) => {
          const value = opt[valueKey];
          const label = getLabel(opt);
          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default injectIntl<SelectInputProps>(SelectInput);
